import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { api } from "../lib/api";

const pin = (n) => L.divIcon({
  className: "",
  html: `<div style="width:34px;height:34px;border-radius:999px;background:#C8A96B;color:#fff;border:3px solid #111;display:flex;align-items:center;justify-content:center;font:600 13px Figtree,sans-serif;box-shadow:0 4px 12px rgba(0,0,0,.35)">${n}</div>`,
  iconSize: [34, 34], iconAnchor: [17, 17],
});

function Fit({ pts }) {
  const map = useMap();
  const key = pts.map((p) => p.join(",")).join("|");
  useEffect(() => { if (pts.length === 1) map.setView(pts[0], 16); else if (pts.length > 1) map.fitBounds(pts, { padding: [40, 40] }); }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export function HuntMap({ pgId }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get(`/party-games/${pgId}/hunt-map`).then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [pgId]);
  if (!d) return null;
  const placed = d.spots.filter((s) => s.lat !== null && s.lat !== "" && s.lng !== null && s.lng !== "");
  if (!d.spots.length) return null;
  return (
    <div data-testid="hunt-live-map">
      <p className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)] mb-2 flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" /> Live check-in map · updates every 10 s</p>
      {placed.length ? (
        <div className="h-72 rounded-xl overflow-hidden border border-[var(--line)] relative z-0">
          <MapContainer center={[Number(placed[0].lat), Number(placed[0].lng)]} zoom={15} className="h-full w-full" scrollWheelZoom={false}>
            <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Fit pts={placed.map((s) => [Number(s.lat), Number(s.lng)])} />
            {placed.map((s) => (
              <React.Fragment key={s.task_id}>
                <Circle center={[Number(s.lat), Number(s.lng)]} radius={d.radius_m} pathOptions={{ color: "#C8A96B", weight: 1, fillOpacity: 0.15 }} />
                <Marker position={[Number(s.lat), Number(s.lng)]} icon={pin(s.checkins.length)}>
                  <Popup><b>{s.title}</b>{s.place_name && <><br />{s.place_name}</>}<br />{s.checkins.length ? s.checkins.slice(0, 12).map((c) => c.name).join(", ") : "No check-ins yet"}</Popup>
                </Marker>
              </React.Fragment>
            ))}
          </MapContainer>
        </div>
      ) : <p className="text-sm text-[var(--muted)]">Add a location to a GPS challenge to see it on the map.</p>}
      <div className="mt-3 space-y-1.5" data-testid="hunt-map-list">
        {d.spots.map((s) => (
          <div key={s.task_id} className="text-sm flex flex-wrap gap-x-2" data-testid={`hunt-map-spot-${s.task_id}`}>
            <b>{s.title}</b><span className="text-[var(--muted)]">· {s.checkins.length} of {d.players} guests checked in</span>
            {s.checkins.length > 0 && <span className="w-full text-xs text-[var(--muted)] truncate">{s.checkins.map((c) => c.name).join(", ")}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
